var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("div", { staticClass: "modal-mask", on: { click: _vm.closeModal } }, [
        _c(
          "div",
          {
            staticClass: "modal-container",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c("h6", { staticClass: "modal-title" }, [
                _vm._v("Affiliate Subscription Details")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.closeModal }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "heading_1 margin-bottom-10" }, [
                _vm._v("\n          Affiliate Name: "),
                _c("span", { staticStyle: { "font-weight": "normal" } }, [
                  _vm._v(_vm._s(_vm.affiliateName))
                ])
              ]),
              _vm._v(" "),
              _vm.license.expireDate > 0
                ? _c(
                    "div",
                    { staticClass: "p-0 col-12" },
                    [
                      _c(
                        "div",
                        { staticClass: "heading_1  margin-bottom-10" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.license.unitType) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 p-0 float-left" }, [
                        _c(
                          "div",
                          { staticClass: "heading_2  margin-bottom-5" },
                          [
                            _vm._v("\n            Name: "),
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "normal" } },
                              [_vm._v(_vm._s(_vm.license.name))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "heading_2  margin-bottom-5" },
                          [
                            _vm._v("\n            Validity Duration: "),
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "normal" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.license.expireDate) + " months"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.license.licenseType == "Bundle License"
                          ? _c(
                              "div",
                              { staticClass: "heading_2  margin-bottom-5" },
                              [
                                _vm._v("\n            Minimum License: "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [_vm._v(_vm._s(_vm.license.minLicense))]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.license.licenseType == "Bundle License"
                          ? _c(
                              "div",
                              { staticClass: "heading_2  margin-bottom-5" },
                              [
                                _vm._v("\n            Bundle Price: "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [
                                    _vm._v(
                                      "$" + _vm._s(_vm.license.bundlePrice)
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.license.licenseType == "Bundle License"
                          ? _c(
                              "div",
                              { staticClass: "heading_2  margin-bottom-5" },
                              [
                                _vm._v("\n            After Bundle Price: "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [
                                    _vm._v(
                                      "$" + _vm._s(_vm.license.afterBundlePrice)
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.license.unitType == "License"
                        ? _c("div", { staticClass: "col-6 p-0 float-left" }, [
                            _c(
                              "div",
                              { staticClass: "heading_2  margin-bottom-5" },
                              [
                                _vm._v("\n            Reassign Window: "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.license.reassignWindow) +
                                        " days"
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "heading_2  margin-bottom-5" },
                              [
                                _vm._v("\n            # of Reassign: "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [_vm._v(_vm._s(_vm.license.noReassign))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "heading_2  margin-bottom-5" },
                              [
                                _vm._v("\n            Probation Window: "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.license.probationWindow) +
                                        " days"
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticStyle: { clear: "both" } }),
                      _vm._v(" "),
                      _vm.license.licenseType == "Normal License"
                        ? _c(
                            "div",
                            { staticClass: "heading_2  margin-bottom-5" },
                            [_vm._v("\n          Tier Price\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.license.licenseType == "Normal License"
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 heading_2 p-0",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "float-left",
                                  staticStyle: { width: "30%" }
                                },
                                [_vm._v("\n            From\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "float-left",
                                  staticStyle: { width: "30%" }
                                },
                                [_vm._v("\n            To\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "float-left",
                                  staticStyle: { width: "40%" }
                                },
                                [_vm._v("\n            Seat Price\n          ")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.license.price, function(price, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-12 heading_2 p-0",
                            staticStyle: {
                              "font-weight": "normal",
                              width: "100%"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "float-left",
                                staticStyle: { width: "30%" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(price.license_from) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "float-left",
                                staticStyle: { width: "30%" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(price.license_to) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "float-left",
                                staticStyle: { width: "40%" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(price.license_price) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _vm.license.unitType == "Seat"
                ? _c("div", { staticClass: "heading_2  margin-bottom-5" }, [
                    _vm._v("\n          Price\n        ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.license.unitType == "Seat"
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 heading_2 p-0",
                      staticStyle: { width: "100%" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "15%" }
                        },
                        [_vm._v("\n            Qty\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "25%" }
                        },
                        [_vm._v("\n            Yearly Price\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "25%" }
                        },
                        [_vm._v("\n            Monthly Price\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "15%" }
                        },
                        [_vm._v("\n            Max Seat\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "20%" }
                        },
                        [_vm._v("\n            Discount\n          ")]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.license.seatPrice, function(price, sindex) {
                  return _c(
                    "div",
                    {
                      key: sindex,
                      staticClass: "col-12 heading_2 p-0",
                      staticStyle: { "font-weight": "normal", width: "100%" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "15%" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(price.license_qty) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "25%" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(price.license_yearly_price) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "25%" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(price.license_monthly_price) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "15%" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(price.max_seat) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "float-left",
                          staticStyle: { width: "20%" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(price.discount) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _vm.license.unitType == "Seat"
                ? _c("div", { staticClass: "col-6 p-0 float-left pt-3" }, [
                    _c("div", { staticClass: "heading_2  margin-bottom-5" }, [
                      _vm._v("\n            Additional Seat Yearly Price: "),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v(_vm._s(_vm.license.additionalYearlyPrice))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "heading_2  margin-bottom-5" }, [
                      _vm._v("\n            Additional Seat Monthly Price: "),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v(_vm._s(_vm.license.additionalMonthlyPrice))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.license.expireDate > 0 && _vm.otp.price > 0
                ? _c("div", {
                    staticStyle: {
                      "border-bottom": "1px solid #00ACEE",
                      margin: "10px 0"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.otp.price > 0
                ? _c("div", { staticClass: "p-0 col-12" }, [
                    _c("div", { staticClass: "heading_1  margin-bottom-10" }, [
                      _vm._v("\n          One Time Purchase\n        ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "heading_2  margin-bottom-5" }, [
                      _vm._v("\n          Licence Name: "),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v(_vm._s(_vm.otp.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "heading_2  margin-bottom-5" }, [
                      _vm._v("\n          Price: "),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v(_vm._s(_vm.otp.price))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eb527e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb527e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/account_lookup_affiliate_price_modal.vue
// module id = null
// module chunks = 